import { Directive, HostBinding, InjectionToken, Input } from '@angular/core';

let nextUniqueId = 0;

/**
 * Injection token that can be used to reference instances of `MatHint`. It serves as
 * alternative token to the actual `MatHint` class which could cause unnecessary
 * retention of the class and its directive metadata.
 */
export const MAT_HINT = new InjectionToken<MatHintDirective>('MatHint');

/**
 * Hint text to be shown underneath the form field control.
 */
@Directive({
  selector: 'app-mat-hint',
  providers: [{ provide: MAT_HINT, useExisting: MatHintDirective }],
})
export class MatHintDirective {
  /** Whether to align the hint label at the start or end of the line. */
  @Input() align: 'start' | 'end' = 'start';

  /** Unique ID for the hint. Used for the aria-describedby on the form field control. */
  @HostBinding('attr.id')
  @Input()
  id: string = `mat-hint-${nextUniqueId++}`;

  @HostBinding('class') readonly hostClass = 'mat-hint';
  @HostBinding('attr.aria-hidden') readonly ariaHidden = 'true';

  // Remove align attribute to prevent it from interfering with layout.
  @HostBinding('attr.align') readonly alignAttr = null;

  @HostBinding('class.mat-form-field-hint-end') get isEndAligned() {
    return this.align === 'end';
  }
}
